module.exports = __webpack_public_path__ + "dingbeauty-build/img/store2_small@2.3105d8c4.jpg";